import React from 'react';

import SmallLinkListItem from './small-link-list-item';

import '../../styles/homepage/small-link-list.scss';

const SmallLinkList = (props) => (
  <div className="small-link-list">
    {props.postEdges.map(({ node }, idx) => (
      <SmallLinkListItem
        key={`small-list-${idx}`}
        node={node}
      />
    ))}
  </div>
);

export default SmallLinkList;